import { Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withTheme, makeStyles } from '@mui/styles';
import styledComponent from 'styled-components';

export const Container = styled(Box)(
  ({ theme }) => `
  margin: auto 100px;
  .btn {
    width: 270px;
    height: 60px;
    font-size: ${theme.typography.h4.fontSize}px;
  }
  ${theme.breakpoints.down('lg')} {
    margin: 20px;
  }
  ${theme.breakpoints.down('md')} {
    margin: 16px;
    .btn {
      width: 152px;
      height: 40px;
      font-size: ${theme.typography.h7.fontSize}px;
    }
    .btn.back {
      width: auto;
      padding: 0;
      color: ${theme.palette.primary.main};
    }
  }
`,
);

export const ImageBox = withTheme(styledComponent(Box)`
  position: relative;
  width: 660px;
  height: 390px;
  text-align: center;
  margin: 0 auto;
  margin-top: 60px;
  img {
    border-radius: 20px;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    width: 90%;
    height: auto;
    padding-bottom: 58%;
    margin-top: 65px;
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    margin-top: 60px;
  }
`);

export const VideoContainer = withTheme(styledComponent(Box)`
  margin-top: 3em;
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    margin-top: 65px;
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    margin-top: 60px;
  }
`);

export const CourseDetailStyle = withTheme(styledComponent(Box)`
  padding-bottom: 70px;
  .fix-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    margin-top: 30px;
    z-index: 8888;
  }
  .pagination-label {
    background: white;
    height: 40px;
  }
  .pagination-label-button {
    background: white;
    width: 40px;
    height: 40px;
  }
  .MuiButtonBase-root.MuiFab-root.Mui-disabled {
    background-color: #F5F5F5;
  }
  .video-plyer {
    width: 100%;
    height: 100%;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0));
  }
  .custom-glance {
    font-family: Lanna;
    font-size: 18px;
  }
  .custom-glance i {
    margin-top: 2px;
    margin-right: 16px;
  }
  .default-glance {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
  }
  .default-glance i {
    font-size: 18px;
    width: 33px;
    color: #00532a;
  }
  .default-glance .subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    font-family: Lanna;
  }
  .container {
    max-width: 1180px;
  }
  .course-description-title-desktop {
    ${(props: any) => props.theme.breakpoints.down('lg')} {
      display: none;
    }
  }
  .course-description-title-mobile {
    ${(props: any) => props.theme.breakpoints.up('lg')} {
      display: none;
    }
  }
  .MuiTabs-indicator {
    height: 6px;
    border-radius: 3px;
    background: #00532a;
  }

  ${(props: any) => props.theme.breakpoints.up('lg')} {
    .container {
      margin: 0 auto;
      height: 100%;
      padding: 0rem 1rem;
      position: relative;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .container {
      margin: 0rem auto;
      height: 100%;
      padding: 0 1rem;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    .container {
      max-width: 1150px;
      height: 100%;
    }
  }
  .description-container {
    font-family: Lanna;
  }
  `);
